import React, {Component} from "react";
import {connect} from 'react-redux';

import styles from './ImageSrcSet.scss';

class ImageSrcSet extends Component {

    render () {
        const src = {
            mobile: this.props.mobile,
            tablet: this.props.tablet,
            desktop: this.props.desktop
        };

        const {breakpoints, greaterThan} = this.props.responsive;
        const fallbackImage = this.fallbackImage(greaterThan, src);

        return (
            <picture className={styles.picture}>
                <source srcSet={src.mobile} media={`(max-width: ${breakpoints.mobile}px)`} />
                <source srcSet={src.tablet} media={`(min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.tablet}px)`} />
                <source srcSet={src.desktop} media={`(min-width: ${breakpoints.tablet}px)`} />
                <img src={fallbackImage} alt={this.props.alt} title={this.props.title} />
            </picture>
        );
    }

    fallbackImage (greaterThan, src) {
        if (greaterThan.tablet) {
            return src.desktop;
        }

        if (greaterThan.mobile) {
            return src.tablet;
        }

        return src.mobile;
    }
}

function mapStateToProps (state) {
    return ({
        responsive: state.responsive
    });
}

export default connect(mapStateToProps)(ImageSrcSet);



// WEBPACK FOOTER //
// ./src/components/ImageSrcSet/index.js